import { render, staticRenderFns } from "./form-committe.vue?vue&type=template&id=54768118&scoped=true"
import script from "./form-committe.vue?vue&type=script&lang=js"
export * from "./form-committe.vue?vue&type=script&lang=js"
import style0 from "./form-committe.vue?vue&type=style&index=0&id=54768118&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54768118",
  null
  
)

export default component.exports